// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Nzzo","content":"styles_content__7VQL6","checkbox":"styles_checkbox__1JIqX","checkboxLabel":"styles_checkboxLabel__2GrAF"};